import { Accordion, AccordionDetails, AccordionSummary, Drawer, IconButton } from '@material-ui/core';
import { Add, Close, ExpandMore } from '@material-ui/icons';
import moment from 'moment';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarEventCard } from './CalendarEventCard';
import GradientButton from '@shared/components/GradientButton';

const EventsDrawer = ({ open, onClose, currentDay, filterEvent, refresh, setRefresh }) => {
	const [expanded, setExpanded] = React.useState(false);
	const navigate = useNavigate();
	const today = moment().startOf('day');

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	const handleClose = () => {
		setExpanded(false);
		onClose();
	};

	const goToCreateEvent = () => {
		handleClose();
		navigate('/calendar-addevent', { state: { date: currentDay?.format('YYYY-MM-DD') } });
	};

	return (
		<Drawer anchor="right" elevation={16} onClose={handleClose} open={open} variant="temporary">
			<div
				className="p-20 min-h-screen w-320 md:w-400 lg:w-640 pt-80"
				style={{
					background: 'linear-gradient(130deg, rgba(244, 249, 255, 1) 0%, rgba(208, 226, 244, 1) 100%)',
				}}
			>
				<IconButton
					className="h-32 p-0 m-0 w-32 flex items-center justify-center absolute top-16 left-8"
					onClick={handleClose}
				>
					<Close className="p-0" />
				</IconButton>
				{currentDay && currentDay.isSameOrAfter(today) ? (
					<div className="absolute top-16 right-8">
						<GradientButton onClick={goToCreateEvent} size="small" variant="tertiary">
							<div className="flex items-center justify-center">
								<Add />
								Add Event
							</div>
						</GradientButton>
					</div>
				) : null}
				<div className="flex items-center pb-8 mb-16">
					<span className="font-bold text-pd-base">{currentDay?.format('dddd, MMMM DD, YYYY')}</span>
				</div>
				<div>
					{filterEvent.length ? (
						filterEvent?.map((event, ind) => {
							const isCustomEvent = event?.type === '39';
							return (
								<Accordion
									aria-controls={`panel${ind}bh-content`}
									className={`flex-col  `}
									expanded={expanded === `panel${ind}`}
									id={`panel${ind}bh-header`}
									key={ind}
									onChange={handleChange(`panel${ind}`)}
								>
									<AccordionSummary expandIcon={<ExpandMore />}>
										<div className="flex items-center gap-16">
											<img
												alt={event?.event_type?.type}
												src={event?.event_type?.icon_url}
												style={{ width: '30px', height: '30px' }}
											/>
											<p>{isCustomEvent ? event?.custom_type : event?.event_type?.type}</p>
										</div>
									</AccordionSummary>
									<AccordionDetails className="">
										<CalendarEventCard
											event={event}
											handleClose={handleClose}
											refresh={refresh}
											setRefresh={setRefresh}
										/>
									</AccordionDetails>
								</Accordion>
							);
						})
					) : (
						<p className="text-center italic mt-64">No Events</p>
					)}
				</div>
			</div>
		</Drawer>
	);
};

export default EventsDrawer;
